import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const AdminGiftPersonalBadge = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('user_id',payload.user_id);
          
           formData.append('badge_id',payload.badge_id);

           try{
               const res = await axios.post(ENDPOINT+"admin-gift-personal-badge.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default AdminGiftPersonalBadge